import { pickBy } from '@/utils'
import AttrNavItem from './attr-imagepanel'

export default {
  name: 'navigation',
  setting: [
    { label: '標題', key: 'title', component: 'input', value: '標題' },
    { label: '副標題', key: 'subtitle', component: 'input', value: '副標題' },
    { label: '元件間距', key: 'padded', component: 'switch', value: true },
    {
      label: '導航項',
      key: 'data',
      component: function (h, { key }) {
        return <AttrNavItem v-model={this.value[key]} />
      },
      value: [
        {
          content: '基礎護膚',
          imgUrl: ''
        },
        {
          content: '彩妝香水',
          imgUrl: ''
        },
        {
          content: '營養保健',
          imgUrl: ''
        },
        {
          content: '滿減優惠',
          imgUrl: ''
        },
        {
          content: '分享拼單',
          imgUrl: ''
        }
      ]
    }
  ],
  transformIn: (v) => {
    const { name, base, config, data } = v
    return {
      name,
      ...base,
      ...config,
      data
    }
  },
  transformOut: (v) => {
    return pickBy(v, {
      name: 'name',
      base: (v) => {
        return pickBy(v, {
          title: 'title',
          subtitle: 'subtitle',
          padded: 'padded'
        })
      },
      data: 'data'
    })
  }
}
